import * as MUI from "@mui/material";
import * as MUIcons from "@mui/icons-material";
import { ComparacaoFotosProps } from "../types/mandado-facial.types";
import { getConfidenceColor } from "../services/reconhecimento-facial.service";

export const ComparacaoFotos: React.FC<ComparacaoFotosProps> = ({
  fotoEnviada,
  fotoBanco,
  grauConfianca,
}) => {
  return (
    <MUI.Box>
      <MUI.Typography variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
        📷 Comparação de Fotos
      </MUI.Typography>

      <MUI.Grid container spacing={2}>
        {/* Foto Enviada */}
        <MUI.Grid item xs={6}>
          <MUI.Paper elevation={2} sx={{ p: 2, textAlign: "center" }}>
            <MUI.Typography
              variant="subtitle2"
              sx={{ mb: 1, fontWeight: "bold" }}
            >
              Foto Enviada
            </MUI.Typography>
            {fotoEnviada ? (
              <MUI.Box
                component="img"
                src={fotoEnviada}
                alt="Foto enviada"
                sx={{
                  width: "100%",
                  height: 200,
                  objectFit: "cover",
                  borderRadius: 1,
                  border: "2px solid",
                  borderColor: "primary.main",
                }}
              />
            ) : (
              <MUI.Box
                sx={{
                  width: "100%",
                  height: 200,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "grey.200",
                  borderRadius: 1,
                }}
              >
                <MUI.Typography variant="body2" color="text.secondary">
                  Sem foto
                </MUI.Typography>
              </MUI.Box>
            )}
          </MUI.Paper>
        </MUI.Grid>

        {/* Foto do Banco */}
        <MUI.Grid item xs={6}>
          <MUI.Paper elevation={2} sx={{ p: 2, textAlign: "center" }}>
            <MUI.Typography
              variant="subtitle2"
              sx={{ mb: 1, fontWeight: "bold" }}
            >
              Foto do Banco
            </MUI.Typography>
            {fotoBanco ? (
              <MUI.Box
                component="img"
                src={`data:image/jpeg;base64,${fotoBanco}`}
                alt="Foto do banco"
                sx={{
                  width: "100%",
                  height: 200,
                  objectFit: "cover",
                  borderRadius: 1,
                  border: "2px solid",
                  borderColor: "success.main",
                }}
              />
            ) : (
              <MUI.Box
                sx={{
                  width: "100%",
                  height: 200,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "grey.200",
                  borderRadius: 1,
                }}
              >
                <MUIcons.ImageNotSupported
                  sx={{ fontSize: 48, color: "grey.500" }}
                />
              </MUI.Box>
            )}
          </MUI.Paper>
        </MUI.Grid>
      </MUI.Grid>

      {/* Grau de Confiança */}
      <MUI.Box sx={{ mt: 2 }}>
        <MUI.Typography variant="body2" sx={{ mb: 1 }}>
          Grau de Confiança:
        </MUI.Typography>
        <MUI.Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <MUI.LinearProgress
            variant="determinate"
            value={grauConfianca * 100}
            sx={{
              flexGrow: 1,
              height: 8,
              borderRadius: 1,
              backgroundColor: "grey.200",
              "& .MuiLinearProgress-bar": {
                backgroundColor: getConfidenceColor(grauConfianca),
              },
            }}
          />
          <MUI.Typography
            variant="body2"
            fontWeight="bold"
            color={getConfidenceColor(grauConfianca)}
          >
            {(grauConfianca * 100).toFixed(1)}%
          </MUI.Typography>
        </MUI.Box>
      </MUI.Box>
    </MUI.Box>
  );
};
